'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Soundcloud';

var EntypoSoundcloud = function EntypoSoundcloud(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M0.672,13.055L1,11.654l-0.328-1.447c-0.009-0.043-0.092-0.076-0.191-0.076c-0.102,0-0.184,0.033-0.191,0.076L0,11.654l0.289,1.4c0.008,0.045,0.09,0.076,0.191,0.076C0.58,13.131,0.663,13.1,0.672,13.055z M2.723,13.832L3,11.668L2.723,8.32C2.714,8.236,2.609,8.168,2.484,8.168c-0.127,0-0.233,0.068-0.238,0.152L2,11.668l0.246,2.164c0.006,0.086,0.111,0.152,0.238,0.152C2.609,13.984,2.714,13.918,2.723,13.832z M4.768,13.797L5,11.67L4.768,7.213C4.762,7.107,4.639,7.025,4.486,7.025c-0.152,0-0.275,0.082-0.281,0.188L4,11.67l0.205,2.129c0.006,0.103,0.129,0.186,0.281,0.186C4.639,13.984,4.762,13.902,4.768,13.797z M6.81,13.766L7,11.67L6.81,7.18C6.805,7.057,6.664,6.959,6.49,6.959c-0.176,0-0.316,0.098-0.321,0.221L6,11.67l0.17,2.096c0.004,0.123,0.145,0.221,0.32,0.221C6.664,13.986,6.805,13.891,6.81,13.766z M8.85,13.738L9,11.672L8.85,6.523C8.846,6.381,8.686,6.268,8.492,6.268c-0.194,0-0.354,0.115-0.357,0.256L8,11.67l0.135,2.068c0.003,0.141,0.163,0.256,0.357,0.256C8.686,13.994,8.846,13.881,8.85,13.738z M10.277,13.996c0.008,0,7.1,0.004,7.145,0.004C18.846,14,20,12.883,20,11.506c0-1.377-1.154-2.492-2.578-2.492c-0.353,0-0.689,0.07-0.996,0.193c-0.205-2.246-2.153-4.008-4.529-4.008c-0.581,0-1.148,0.111-1.648,0.297C10.053,5.57,10.002,5.644,10,5.791v7.91C10.002,13.854,10.124,13.98,10.277,13.996z' })
    );
};

exports.default = EntypoSoundcloud;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Soundcloud.js
// module id = ./node_modules/react-entypo/lib/entypo/Soundcloud.js
// module chunks = 2